export const toCamelCase = (str: string): string => str.replace(/_([a-z])/g, (_match, letter) => letter.toUpperCase());
